import ModelEditDto from 'app/admin/model/dto/ModelEditDto';
import OpcModelAttributeEditDto from './OpcModelAttributeEditDto';

export class OpcModelEditDto extends ModelEditDto {
	constructor() {
		super();
		/** @type {string} */
		this.endpoint = null;
		/** @type {OpcModelAttributeEditDto[]} */
		this.inputAttributes = null;
		/** @type {OpcModelAttributeEditDto[]} */
		this.outputAttributes = null;
	}

	/**
	 * @typedef {Object} _OpcModelEditDtoProps
	 * @property {string} endpoint
	 * @property {OpcModelAttributeEditDto[]} inputAttributes
	 * @property {OpcModelAttributeEditDto[]} outputAttributes
	 *
	 * @typedef {import("app/admin/model/dto/ModelEditDto").ModelEditDtoProps & _OpcModelEditDtoProps} OpcModelEditDtoProps
	 */
	/**
	 *
	 * @param {OpcModelEditDtoProps} props
	 * @returns {OpcModelEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.endpoint = props.endpoint;
		this.inputAttributes = props.inputAttributes !== null ? props.inputAttributes.map(d => new OpcModelAttributeEditDto().setup(d)) : [];
		this.outputAttributes = props.outputAttributes !== null ? props.outputAttributes.map(d => new OpcModelAttributeEditDto().setup(d)) : [];
		return this;
	}
}

export default OpcModelEditDto;
